import { Injectable } from '@angular/core';
import { IStorageService } from 'src/app/services/storage.service';
import {
    USER_ID_KEY,
    EMAIL_ID_KEY,
    MASTER_NODEBOXTYPES_KEY,
    MASTER_TRANSFORMERS_KEY,
    MASTER_FARMTYPE_KEY,
    SELECTED_NODE_DETAILS_KEY,
    SELECTED_REFINERY_DETAILS_KEY,
    SELECTED_CONFIG_JSON_KEY,
    PARENT_DATA_NODE_KEY,
    ATTRIBUTION_NODE_KEY,
    SELECTED_TAB_INDEX_KEY,
    SELECTED_TRANSFORM_KEY,
    SELECTED_DATA_TRANSFORM_CONFIG_KEY,
    OUTPUT_DATA_KEY,
    USER_NAME_KEY,
    LOOKUP_TAB_CLICKED_KEY,
    RESULTS_TAB_CLICKED_KEY,
    OUTPUT_TAB_CLICKED_KEY,
    APPLYFILTER_BTN_CLICKED_KEY,
    TOCLEARACTIVEFILTERS_KEY,
    INPUT_TAB_CLICKED_KEY,
    RAW_TAB_CLICKED_KEY,
    INPUTPRVWFILTER_VM_KEY,
    SELECTED_INGESTFARM_GUID,
    SELECTED_GRAPH_WIDTH_KEY,
    SELECTED_GRAPH_HEIGHT_KEY,
    ORGANIZATIONID_ID_KEY,
    USER_DATA_KEY,
    ORGANIZATIONID_NAME_KEY,
    ORG_DATA_KEY,
    RAW_DATACONNECTOR_MAPPING_KEY,
    RAW_GENERAL_PARAM_KEY,
    SESSION_TIMEOUT_DATA_KEY,
    INGESTINPUT_TAB_CLICKED_KEY,
    SUMMARY_TAB_CLICKED_KEY,
    PROCESSR_INPUTSUMMRYPREVW_CLICKED_KEY,
    DATA_PREVIEW_NODEID_KEY,
    TRANSFORM_ID_KEY,
    NODE_ID_KEY,
    REFINERY_ID_KEY,
    ORG_ID_KEY,
    INGEST_ID_KEY,
    SUMMARY_SELECT_VALUE_KEY,
    SUMMARY_EMPTY_COLUMNS_KEY,
    SUMMARY_FILTER_PREFS_KEY,
    SUMMARY_FILTER_KEY,
    SUMMARY_SORT_KEY,
    SELECTED_INGEST_MAPPING_GUID_KEY,
    SELECTED_INGEST_MAPPING_TYPE_KEY
} from 'src/app/constants/constant';
import { Router } from '@angular/router';
import { AppEnvService } from 'src/app/services/app-env.service';
import { DataRefineryConfig } from '../domainObjects/dataRefineryConfig';
import { Edge, Node} from '@swimlane/ngx-graph';
import { NodeViewModel } from '../domainObjects/nodeViewModel';
import { DataTransformerConfig } from '../domainObjects/dataTransformConfig';
import { FarmType, NodeBoxType, Transformers } from '../domainObjects/masterConfig';
import { TransformerViewModel } from '../views/transformer-list/transformer-list.component';
import { DataTransformConfigViewModel } from '../viewModels/dataTransformConfigViewModel';
import { ColumnInfo, PreviewTableComponent } from '../views/preview-table/preview-table.component';
import { ExportColumnInfo } from '../viewModels/exportViewModel';
import { InputPrvwFilterViewModel } from '../viewModels/inputPrvwFilterViewModel';
import { DataConnectorMapping } from '../domainObjects/dataConnectorMapping';
import { GeneralParameter } from '../domainObjects/ingestTransforms';
import { PreviewDataOptions } from '../domainObjects/previewDataOptions';
import { ColumnFilterInfo } from '../views/previewTable/filterUI/column-filter/column-filter.component';
import { SortInfo } from '../domainObjects/sortInfo';

@Injectable({
    providedIn: 'root'
})
export class UserDataService {
    constructor(
        private storage: IStorageService,
        private router: Router,
        private appEnvService: AppEnvService) {
    }
    
    setUserId(id: string): void {
        this.storage.set(USER_ID_KEY, id);
    }

    getUserId(): string {
        return this.storage.get(USER_ID_KEY);
    }

    setOrgId(id: string): void {
        this.storage.set(ORG_ID_KEY, id);
    }

    getOrgId(): string {
        return this.storage.get(ORG_ID_KEY);
    }

    setRefineryId(id: string): void {
        this.storage.set(REFINERY_ID_KEY, id);
    }

    getRefineryId(): string {
        return this.storage.get(REFINERY_ID_KEY);
    }

    setNodeId(id: string): void {
        this.storage.set(NODE_ID_KEY, id);
    }

    getNodeId(): string {
        return this.storage.get(NODE_ID_KEY);
    }

    setTransformId(id: string): void {
        this.storage.set(TRANSFORM_ID_KEY, id);
    }

    getTransformId(): string {
        return this.storage.get(TRANSFORM_ID_KEY);
    }

    setIngestId(id: string): void {
        this.storage.set(INGEST_ID_KEY, id);
    }

    getIngestId(): string {
        return this.storage.get(INGEST_ID_KEY);
    }

    setUserName(id: string): void {
        this.storage.set(USER_NAME_KEY, id);
    }

    getUserName(): string {
        return this.storage.get(USER_NAME_KEY);
    }

    setEmailId(emailid: string): void {
        this.storage.set(EMAIL_ID_KEY, emailid);
    }

    getEmailId(): string {
        return this.storage.get(EMAIL_ID_KEY);
    }

    clear(): void {
        this.storage.clearStorage();
    }

    clearKey(key: string): void {
        this.storage.clear(key);
    }

    getSelectedRefineryDetails(): DataRefineryConfig {
        return this.storage.get<DataRefineryConfig>(SELECTED_REFINERY_DETAILS_KEY);
    }

    clearSelectedRefineryDetails(){
        this.storage.clear(SELECTED_REFINERY_DETAILS_KEY);
    }

    setSelectedRefineryDetails(selectedRefinerDetails: DataRefineryConfig): void {
        this.storage.set<DataRefineryConfig>(SELECTED_REFINERY_DETAILS_KEY, selectedRefinerDetails);
    }

    getSelectedNodeDetails(): NodeViewModel {
        return this.storage.get(SELECTED_NODE_DETAILS_KEY);
    }

    setSelectedNodeDetails(selectedNodeDetails: NodeViewModel): void {
        this.storage.set(SELECTED_NODE_DETAILS_KEY, selectedNodeDetails);
    }

    getSelectedConfigJson(): DataTransformerConfig {
        return this.storage.get(SELECTED_CONFIG_JSON_KEY);
    }

    setSelectedConfigJson(configjson: DataTransformerConfig): void {
        this.storage.set(SELECTED_CONFIG_JSON_KEY, configjson);
    }

    getSelectedTransform(): TransformerViewModel {
        return this.storage.get(SELECTED_TRANSFORM_KEY);
    }

    setSelectedTransform(transform: TransformerViewModel): void {
        this.storage.set(SELECTED_TRANSFORM_KEY, transform);
    }

    getSelectedDataTransformConfigViewModel(): DataTransformConfigViewModel {
        return this.storage.get(SELECTED_DATA_TRANSFORM_CONFIG_KEY);
    }

    setSelectedDataTransformConfigViewModel(transform: DataTransformConfigViewModel): void {
        this.storage.set(SELECTED_DATA_TRANSFORM_CONFIG_KEY, transform);
    }
    setGraphWidth(graphWidth: number): void {
        this.storage.set(SELECTED_GRAPH_WIDTH_KEY, graphWidth);
    }

    getGraphWidth(): number {
        return this.storage.get(SELECTED_GRAPH_WIDTH_KEY);
    }
    setGraphHeight(graphHeight: number): void {
        this.storage.set(SELECTED_GRAPH_HEIGHT_KEY, graphHeight);
    }

    getGraphHeight(): number {
        return this.storage.get(SELECTED_GRAPH_HEIGHT_KEY);
    }
    //TEST
    getOutputData(): ExportColumnInfo[] {
        return this.storage.get(OUTPUT_DATA_KEY);
    }

    setOutputData(outputdata: ExportColumnInfo[]): void {
        this.storage.set(OUTPUT_DATA_KEY, outputdata);
    }
    //END TEST
//#selectedTabIndex After rework in config detail it may not be used
    getSelectedTabIndex(): number {
        return this.storage.get(SELECTED_TAB_INDEX_KEY);
    }

    setSelectedTabIndex(selectedTabIndex: number): void {
        this.storage.set(SELECTED_TAB_INDEX_KEY, selectedTabIndex);
    }
    //#selectedTabIndex
    //#sourcenodelink May be change duplicate of getSelectedNodeDetails().sourcenodelink
    getNodeParentDataLine(): Edge[] {
        return this.storage.get(PARENT_DATA_NODE_KEY);
    }
    setNodeParentDataLine(links: Edge[]): void {
        this.storage.set(PARENT_DATA_NODE_KEY, links);
    }
    getNodeAttributionLine(): Edge[] {
        return this.storage.get(ATTRIBUTION_NODE_KEY);
    }
    setNodeAttributionLine(links: Edge[]): void {
        this.storage.set(ATTRIBUTION_NODE_KEY, links);
    }
    //#sourcenodelink end
//set Master json values
    setMasterNodeBoxTypes(nodeboxtypes: NodeBoxType[]): void {
        this.storage.set<NodeBoxType[]>(MASTER_NODEBOXTYPES_KEY, nodeboxtypes);
    }

    getMasterNodeBoxTypes(): NodeBoxType[] {
        return this.storage.get<NodeBoxType[]>(MASTER_NODEBOXTYPES_KEY);
    }

    setMasterTransformers(transformers: Transformers[]): void {
        this.storage.set<Transformers[]>(MASTER_TRANSFORMERS_KEY, transformers);
    }

    getMasterTransformers(): Transformers[] {
        return this.storage.get<Transformers[]>(MASTER_TRANSFORMERS_KEY);
    }

    setMasterFarmtypes(farmtypes: FarmType[]): void {
        this.storage.set<FarmType[]>(MASTER_FARMTYPE_KEY, farmtypes);
    }

    getMasterFarmtypes(): FarmType[] {
        return this.storage.get<FarmType[]>(MASTER_FARMTYPE_KEY);
    }

    setInputTabDataFrFilter(inputPrvwFilterViewModel: InputPrvwFilterViewModel): void {
       this.storage.set<InputPrvwFilterViewModel>(INPUTPRVWFILTER_VM_KEY, inputPrvwFilterViewModel)
    }

    getInputTabDataFrFilter(): InputPrvwFilterViewModel {
        return this.storage.get(INPUTPRVWFILTER_VM_KEY);
    }

    setLookupTabClicked(isLookupTabClicked: Boolean): void {
        this.storage.set(LOOKUP_TAB_CLICKED_KEY, isLookupTabClicked)
    }

    getLookupTabClicked(): Boolean {
        return this.storage.get(LOOKUP_TAB_CLICKED_KEY)
    }

    setResultsTabClicked(isResultsTabClicked: Boolean): void {
        this.storage.set(RESULTS_TAB_CLICKED_KEY, isResultsTabClicked)
    }

    getResultsTabClicked(): Boolean {
        return this.storage.get(RESULTS_TAB_CLICKED_KEY)
    }

    setInputTabClicked(isInputTabClicked: Boolean): void {
        this.storage.set(INPUT_TAB_CLICKED_KEY, isInputTabClicked)
    }

    getInputTabClicked(): Boolean {
        return this.storage.get(INPUT_TAB_CLICKED_KEY) 
    }

    setOutputTabClicked(isOutputTabClicked: Boolean): void {
        this.storage.set(OUTPUT_TAB_CLICKED_KEY, isOutputTabClicked)
    }

    getOutputTabClicked(): Boolean {
        return this.storage.get(OUTPUT_TAB_CLICKED_KEY) 
    }

    setSummaryTabClicked(isSummaryTabClicked: Boolean): void {
        this.storage.set(SUMMARY_TAB_CLICKED_KEY, isSummaryTabClicked)
    }

    getSummaryTabClicked(): Boolean {
        return this.storage.get(SUMMARY_TAB_CLICKED_KEY) 
    }

    setRawTabClicked(isRawTabClicked: Boolean): void {
        this.storage.set(RAW_TAB_CLICKED_KEY, isRawTabClicked)
    }

    getRawTabClicked(): Boolean {
        return this.storage.get(RAW_TAB_CLICKED_KEY) 
    }

    setIsProcessrInputsummryprevwClicked(isProcessrInputsummryprevwClicked: Boolean): void {
        this.storage.set(PROCESSR_INPUTSUMMRYPREVW_CLICKED_KEY, isProcessrInputsummryprevwClicked)
    }

    getIsProcessrInputsummryprevwClicked(): Boolean {
        return this.storage.get(PROCESSR_INPUTSUMMRYPREVW_CLICKED_KEY) 
    }

    setApplyFilterBtnClicked(isApplyFilterBtnClicked: Boolean): void  {
        this.storage.set(APPLYFILTER_BTN_CLICKED_KEY, isApplyFilterBtnClicked)
    }

    getApplyFilterBtnClicked(): Boolean {
        return this.storage.get(APPLYFILTER_BTN_CLICKED_KEY);
    }

    setToClearActiveFilters(toClearActiveFilters: Boolean): void {
       this.storage.set(TOCLEARACTIVEFILTERS_KEY, toClearActiveFilters)
    }

    getToClearActiveFilters(): Boolean {
        return this.storage.get(TOCLEARACTIVEFILTERS_KEY);
    }

    getSelectedIngestFarmGUID(): string {
        return this.storage.get(SELECTED_INGESTFARM_GUID);
    }

    setSelectedIngestFarmGUID(selectedIngestFarmGUID: string): void {
        this.storage.set(SELECTED_INGESTFARM_GUID, selectedIngestFarmGUID);
    }
    setSelectedOrganization(selectedOrganizationId: number): void { 
        this.storage.set(ORGANIZATIONID_ID_KEY, selectedOrganizationId);
      }     
      getSelectedOrganization(): number {
        return this.storage.get(ORGANIZATIONID_ID_KEY);
    }
    setUserData(response: any): void {
        localStorage.setItem(USER_DATA_KEY, response);
      }
    
      getUserData(): any {
        const userData = localStorage.getItem(USER_DATA_KEY);
        return userData ? JSON.parse(userData) : null;
      }
      setOrgData(response: any): void {
        localStorage.setItem(ORG_DATA_KEY, response);
      }
    
      getOrgData(): any {
        const orgData = localStorage.getItem(ORG_DATA_KEY);
        return orgData ? JSON.parse(orgData) : null;
      }

      // The signed-in user's organizations, as written at login ('userOrgs'). Read
      // directly rather than through this.storage, because login stores it as plain
      // JSON; the encrypting storage.get() would fail on it if encryption were enabled.
      getUserOrgs(): any[] {
        return JSON.parse(localStorage.getItem('userOrgs') || '[]');
      }


      setUserSessionTimeoutData(timeout: number): void { 
        this.storage.set(SESSION_TIMEOUT_DATA_KEY, timeout);
      }     
      getUserSessionTimeoutData(): number {
        return this.storage.get(SESSION_TIMEOUT_DATA_KEY);
    }

      setSelectedOrganizationName(organizationName: string): void { 
        this.storage.set(ORGANIZATIONID_NAME_KEY, organizationName);
      }     
      getSelectedOrganizationName(): string {
        return this.storage.get(ORGANIZATIONID_NAME_KEY);
    }

    setRawdataconnectorMapping(rawdataconnectormapping: DataConnectorMapping): void {
        this.storage.set(RAW_DATACONNECTOR_MAPPING_KEY, rawdataconnectormapping)
    }

    getRawdataconnectorMapping(): DataConnectorMapping {
        return this.storage.get(RAW_DATACONNECTOR_MAPPING_KEY)
    }

    setRawGeneralParams(rawgeneralparams: GeneralParameter): void {
        this.storage.set(RAW_GENERAL_PARAM_KEY, rawgeneralparams)
    }

    getRawGeneralParams(): GeneralParameter {
        return this.storage.get(RAW_GENERAL_PARAM_KEY)
    }
    
    setIngestInputTabClicked(isIngestInputTabClicked: Boolean): void {
        this.storage.set(INGESTINPUT_TAB_CLICKED_KEY, isIngestInputTabClicked)
    }

    getIngestInputTabClicked(): Boolean {
        return this.storage.get(INGESTINPUT_TAB_CLICKED_KEY) 
    }

    setDataPreviewNodeId(nodeid: string): void {
        this.storage.set(DATA_PREVIEW_NODEID_KEY, nodeid);
    }

    getDataPreviewNodeId(): string {
        return this.storage.get(DATA_PREVIEW_NODEID_KEY);
    }

    //Set user data end summary filter prefs
    setSelectValues(key: string, value: any[]): void {
        this.storage.set(key+"_"+SUMMARY_SELECT_VALUE_KEY, value);
    }
    getSelectValues(key: string): any[] {
        return this.storage.get(key+"_"+SUMMARY_SELECT_VALUE_KEY);
    }

    setSelectEmptyColumns(key: string, value: any[]): void {
        this.storage.set(key+"_"+SUMMARY_EMPTY_COLUMNS_KEY, value);
    }
    getSelectEmptyColumns(key: string): any[] {
        return this.storage.get(key+"_"+SUMMARY_EMPTY_COLUMNS_KEY);
    }

    setSelectFilterValues(key: string, value: any[]): void {
        this.storage.set(key+"_"+SUMMARY_FILTER_PREFS_KEY, value);
    }
    getSelectFilterValues(key: string): any[] {
        return this.storage.get(key+"_"+SUMMARY_FILTER_PREFS_KEY);
    }

    setSummaryFilter(key: string, value: ColumnFilterInfo[]): void {
        this.storage.set(key+"_"+SUMMARY_FILTER_KEY, value);
    }
    getSummaryFilter(key: string): ColumnFilterInfo[] {
        return this.storage.get(key+"_"+SUMMARY_FILTER_KEY);
    }
    
    setSummarySort(key: string, value: SortInfo[]): void {
        this.storage.set(key+"_"+SUMMARY_SORT_KEY, value);
    }
    getSummarySort(key: string): SortInfo[] {
        return this.storage.get(key+"_"+SUMMARY_SORT_KEY);
    }

    setSelectedIngestMappingGUID(value: string): void {
        this.storage.set(SELECTED_INGEST_MAPPING_GUID_KEY, value);
    }
    getSelectedIngestMappingGUID(): string {
        return this.storage.get(SELECTED_INGEST_MAPPING_GUID_KEY);
    }

    setSelectedIngestMappingType(value: string): void {
        this.storage.set(SELECTED_INGEST_MAPPING_TYPE_KEY, value);
    }
    getSelectedIngestMappingType(): string {
        return this.storage.get(SELECTED_INGEST_MAPPING_TYPE_KEY);
    }
}
